import { suboxone } from './initial';
import { suboxoneFollowup } from './followup';

const SuboxoneFlows = {
  suboxone,
  suboxoneFollowup
};

export default SuboxoneFlows;
